module.exports = __webpack_public_path__ + "img/restaurant.aa310275.png";